import { render, staticRenderFns } from "./lk-competencies-item.vue?vue&type=template&id=2be0c9ae&"
import script from "./lk-competencies-item.vue?vue&type=script&lang=js&"
export * from "./lk-competencies-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-competencies-item/lk-competencies-item.vue
// module id = 447
// module chunks = 0